import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLogging } from '../../context/LoggingContext';
import { useAnalytics } from '../../context/FirebaseContext';

const RouteTracker = () => {
  const location = useLocation();
  const { logNavigation } = useLogging();
  const { trackPageView } = useAnalytics();
  const previousPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;

    // Track page view when location changes
    trackPageView(currentPath);

        // Log navigation to our custom logging system
        if (previousPath.current !== null && previousPath.current !== currentPath) {
          logNavigation(previousPath.current, currentPath);
        }
  }, [location, trackPageView, logNavigation]);
  
  return null; // This component doesn't render anything
};

export default RouteTracker;